import React, { Component } from 'react';
import { Card, CardHeader, CardContent, Typography } from '@mui/material';

class CardSimple extends Component {
    render() {
        const p = this.props;
        return (
            <Card className={`CardSimple ${p.className} mb-2`} sx={{ '& .MuiCardContent-root': p.cardStyles }}>
                {p.title && (<CardHeader title={p.title} subtitle={p.subtitle || ""} />)}
                <CardContent>
                    {p.children}
                </CardContent>
            </Card>
        );
    }
}

export default (CardSimple);